import _ from 'lodash';
import store from '$$globalStore';
import helpers from './helpers';

export default {
  fromStore(tasksToDelete, ganttInstance) {
    ganttInstance.batchUpdate(() => {
      const parentsToRefresh = [];

      tasksToDelete.forEach(task => {
        if (!ganttInstance.isTaskExists(task.id)) {
          return;
        }

        if (task.parent) {
          parentsToRefresh.push(task.parent);
        }

        ganttInstance.silent(() => {
          ganttInstance.deleteTask(task.id);
        });
      });

      if (parentsToRefresh.length) {
        helpers.updateButtonsInTasks(ganttInstance, parentsToRefresh);
      }
    });

    ganttInstance.callEvent('onAfterDeleteTasksFromStore');
  },

  fromGantt(tasksToUpdate, ganttInstance) {
    const tasksMap = store.getters['tasksModel/getProjectTasksMap'](tasksToUpdate[0].data.gantt_id);
    const newTasksData = [];
    const diff = {
      tasks: {},
      links: {},
    };

    tasksToUpdate.forEach(taskFromGantt => {
      if (taskFromGantt.type === 'task' || taskFromGantt.type === 'project') {
        const taskFromStore = _.cloneDeep(tasksMap[taskFromGantt.id]);
        const taskDiff = store.getters['tasksModel/getDiff'](taskFromGantt.data, taskFromStore);

        diff.tasks[taskFromGantt.id] = taskDiff;

        taskFromStore.duration = taskFromGantt.data.duration;
        taskFromStore.start_date = taskFromGantt.data.start_date;
        taskFromStore.end_date = taskFromGantt.data.end_date;
        taskFromStore.progress = taskFromGantt.data.progress;
        taskFromStore.color = taskFromGantt.data.color;

        newTasksData.push(taskFromStore);
      }
    });

    store.dispatch('tasksModel/updateTasks', {
      tasks: newTasksData,
      diff,
      links: [],
      isGanttEvent: true,
    });
  },
};
